(function () {
  var PANEL_ID = "OptionHelpPanel";
  var SCOPE_SELECTOR = ".product-info";
  var LABEL_SELECTORS = [".product-info-app .selector-wrapper > .bcpo-label"];
  var FLAG = "optionHelpBound";

  function normalize(value) {
    return (value || "")
      .replace(/\s+/g, " ")
      .replace(/^([^:：]+)[:：].+$/, "$1")
      .replace(/[:：*.\s]+$/g, "")
      .trim()
      .toLowerCase();
  }

  function ownText(element) {
    var text = "";
    element.childNodes.forEach(function (node) {
      if (node.nodeType === 3) text += node.textContent;
    });
    return text.trim() || element.textContent.trim();
  }

  function buildMap() {
    var map = {};
    document.querySelectorAll(".option-help-item").forEach(function (template) {
      (template.getAttribute("data-keys") || "").split("|").forEach(function (key) {
        var normalizedKey = normalize(key);
        if (normalizedKey) map[normalizedKey] = template;
      });
    });
    return map;
  }

  function makeTrigger(key) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "option-help-trigger";
    button.setAttribute("data-help-key", key);
    button.setAttribute("aria-label", "More info");
    button.innerHTML =
      '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true">' +
      '<circle cx="12" cy="12" r="9" fill="none" stroke="currentColor" stroke-width="1.6"/>' +
      '<path d="M9.6 9.3a2.4 2.4 0 1 1 3.3 2.2c-.8.4-1 .8-1 1.6v.4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
      '<circle cx="12" cy="16.6" r="1" fill="currentColor"/></svg>';
    return button;
  }

  var linkTemplates = {};

  function buildLinkList() {
    var list = [];
    linkTemplates = {};
    document.querySelectorAll(".option-help-link-item").forEach(function (template, index) {
      var id = "link" + index;
      linkTemplates[id] = template;
      (template.getAttribute("data-keys") || "").split("|").forEach(function (key) {
        var normalizedKey = normalize(key);
        if (normalizedKey) list.push({ key: normalizedKey, template: template, id: id });
      });
    });
    return list;
  }

  function findLinkMatches(links, labelText) {
    var key = normalize(labelText);
    if (!key) return [];
    return links.filter(function (item) {
      return key === item.key || key.indexOf(item.key) === 0;
    });
  }

  function makeTextLink(item) {
    var link = document.createElement("a");
    link.className = "option-help-textlink";
    link.textContent = item.template.getAttribute("data-link-label") || "";
    link.setAttribute("data-help-link-id", item.id);
    var color = item.template.getAttribute("data-link-color");
    if (color) link.style.color = color;
    var url = item.template.getAttribute("data-link-url");
    if (url) {
      link.href = url;
    } else {
      link.href = "#";
      link.setAttribute("data-help-link-panel", "1");
    }
    return link;
  }

  function findTemplate(map, labelText) {
    var key = normalize(labelText);
    if (!key) return null;

    if (map[key]) return { template: map[key], key: key };

    for (var mapKey in map) {
      if (key.indexOf(mapKey) === 0) {
        return { template: map[mapKey], key: mapKey };
      }
    }

    return null;
  }

  function inject(scope, map, links) {
    LABEL_SELECTORS.forEach(function (selector) {
      scope.querySelectorAll(selector).forEach(function (element) {
        var labelText = ownText(element);

        if (!element.dataset[FLAG] && !element.querySelector(".option-help-trigger")) {
          var match = findTemplate(map, labelText);
          if (match) {
            element.dataset[FLAG] = "1";
            var host = element.querySelector(".bcpo-title") || element;
            host.classList.add("has-option-help");
            host.appendChild(makeTrigger(match.key));
          }
        }

        var matches = findLinkMatches(links, labelText);
        if (matches.length) {
          var container = element.nextElementSibling;
          if (!container || !container.classList.contains("option-help-textlinks")) {
            container = document.createElement("div");
            container.className = "option-help-textlinks";
            element.parentNode.insertBefore(container, element.nextSibling);
          }
          matches.forEach(function (item) {
            if (container.querySelector('[data-help-link-id="' + item.id + '"]')) return;
            container.appendChild(makeTextLink(item));
          });
        }
      });
    });
  }

  var pageCache = {};

  function setPanelLabel(panel, content) {
    var dialog = panel.querySelector(".option-help-panel__inner");
    if (!dialog) return;
    var title = content.querySelector(".option-help__title");
    if (title) {
      title.id = "OptionHelpPanelTitle";
      dialog.setAttribute("aria-labelledby", "OptionHelpPanelTitle");
    } else {
      dialog.removeAttribute("aria-labelledby");
    }
  }

  function renderRemotePage(html, content, panel) {
    var doc = new DOMParser().parseFromString(html, "text/html");
    var main = doc.querySelector("#MainContent");
    var loadingEl = content.querySelector(".option-help__loading");
    if (!main) {
      if (loadingEl) loadingEl.classList.add("is-error");
      return;
    }
    main.querySelectorAll('[id*="__breadcrumb"], script, noscript').forEach(function (node) {
      node.remove();
    });
    if (loadingEl) loadingEl.remove();
    var wrap = document.createElement("div");
    wrap.className = "option-help__remote";
    wrap.innerHTML = main.innerHTML;
    content.appendChild(wrap);
    setPanelLabel(panel, content);
  }

  function loadRemotePage(url, content, panel) {
    if (pageCache[url]) {
      renderRemotePage(pageCache[url], content, panel);
      return;
    }
    fetch(url, { credentials: "same-origin" })
      .then(function (response) {
        return response.ok ? response.text() : Promise.reject(response.status);
      })
      .then(function (html) {
        pageCache[url] = html;
        renderRemotePage(html, content, panel);
      })
      .catch(function () {
        var loadingEl = content.querySelector(".option-help__loading");
        if (loadingEl) loadingEl.classList.add("is-error");
      });
  }

  function openPanelFromTemplate(template) {
    var panel = document.getElementById(PANEL_ID);
    if (!panel || !template) return;

    var content = panel.querySelector("[data-help-content]");
    content.innerHTML = "";
    content.appendChild(template.content.cloneNode(true));

    var pageUrl = template.getAttribute("data-help-page-url");
    if (pageUrl) {
      panel.classList.add("option-help-panel--page");
      var loadingEl = document.createElement("div");
      loadingEl.className = "option-help__loading";
      loadingEl.setAttribute("aria-live", "polite");
      loadingEl.innerHTML = '<span class="option-help__spinner" aria-hidden="true"></span>';
      content.appendChild(loadingEl);
      setPanelLabel(panel, content);
      loadRemotePage(pageUrl, content, panel);
    } else {
      panel.classList.remove("option-help-panel--page");
      setPanelLabel(panel, content);
    }

    panel.show();
  }

  function openPanel(key) {
    openPanelFromTemplate(buildMap()[key]);
  }

  function init() {
    if (!document.getElementById(PANEL_ID)) return;

    var scope = document.querySelector(SCOPE_SELECTOR) || document.body;
    inject(scope, buildMap(), buildLinkList());

    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        inject(scope, buildMap(), buildLinkList());
      });
    }).observe(scope, { childList: true, subtree: true });

    document.addEventListener("click", function (event) {
      var trigger = event.target.closest && event.target.closest(".option-help-trigger");
      if (trigger) {
        event.preventDefault();
        event.stopPropagation();
        openPanel(trigger.getAttribute("data-help-key"));
        return;
      }

      var link = event.target.closest && event.target.closest(".option-help-textlink[data-help-link-panel]");
      if (!link) return;
      event.preventDefault();
      event.stopPropagation();
      openPanelFromTemplate(linkTemplates[link.getAttribute("data-help-link-id")]);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
